<template>
  <ol class="breadcrumb" :class="{ 'breadcrumb--ml': !hasMainMenuOpen }">
    <li class="breadcrumb__item">
      <router-link :to="{ name: 'Dashboard' }" :title="$t('Views.DashboardPage.title')">
        <v-icon color="gray-6">home</v-icon>
      </router-link>
    </li>

    <li
      v-for="(route, index) in routes"
      :key="`item-${index}`"
      class="breadcrumb__item"
      :class="{ 'breadcrumb__item--active': currentRouteName === route.name }"
    >
      <v-icon>keyboard_arrow_right</v-icon>
      <span
        v-if="currentRouteName === route.name || !route.name"
        :title="route.title"
      >{{ route.title | ellipsis(35) }}</span>
      <router-link
        v-else
        :to="{ name: route.name }" :title="route.title"
        class="breadcrumb__item__link"
      >{{ route.title }}</router-link>
    </li>
  </ol>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Breadcrumb',
  props: {
    routes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    currentRouteName () {
      return this.$route.name
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  flex-direction: row;

  &.breadcrumb--ml {
    margin-left: 0;

    @media (min-width: 961px) {
      margin-left: 100px;
    }
  }
}

.breadcrumb__item {

  &:first-child {

    .v-icon {
      font-size: 16px;
      line-height: 1;
      position: relative;
      top: -1px;
    }
  }

  a {
    color: var(--gray-7);
    text-decoration: none;
  }

  .v-icon {
    font-size: 20px;
  }
}

.breadcrumb__item--active {
  font-weight: 600;
}

.breadcrumb__item__link {

  &:hover {
    text-decoration: underline;
  }
}
</style>
